// assets
import BallotIcon from '@mui/icons-material/Ballot';

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const providers = {
  id: 'providers',
  title: 'Proveedores',
  type: 'group',
  children: [
    {
      id: 'providers-list',
      title: 'Lista Proveedores',
      type: 'item',
      url: '/providers-list',
      icon: BallotIcon,
      breadcrumbs: false
    }
  ]
};

export default providers;
